import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FilterBuilderOutput, FilterBuilderParam } from 'src/app/models/filter-builder';
import { ColumnOption } from 'src/app/models/grid-settings';
import { ScheduledExport, ShapefileValidationCriteria } from 'src/app/models/scheduled-export';
import { ItemSearchFilter, ItemSearchOptionField } from 'src/app/components/filter-list/models/filterClasses';

export interface ScheduledExportOverlayData {
  componentId: string;
  title: string;
  params: FilterBuilderParam[];
  currentFilters: FilterBuilderOutput | ItemSearchOptionField[];
  staticFilters: ItemSearchOptionField[] | ItemSearchFilter;
  currentColumnOptions: ColumnOption[];
  shapefileValidationCriteria: ShapefileValidationCriteria;
  scheduledExport?: ScheduledExport;
}

@Injectable({
  providedIn: 'root'
})
export class ScheduledExportOverlayService {

  private STORAGE_KEY = 'scheduledExportOverlay';

  private overlayDataSubject = new BehaviorSubject<ScheduledExportOverlayData | null>(null);

  overlayData$ = this.overlayDataSubject.asObservable();

  private savedSubject = new BehaviorSubject<boolean>(false);
  saved$ = this.savedSubject.asObservable();

  constructor() {
    const stored = sessionStorage.getItem(this.STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        this.overlayDataSubject.next(parsed);
      } catch {
        sessionStorage.removeItem(this.STORAGE_KEY);
      }
    }
  }

  notifySaved() {
    this.savedSubject.next(true);
  }

  clearSaved() {
    this.savedSubject.next(false);
  }


  setData(data: ScheduledExportOverlayData) {
    this.overlayDataSubject.next(data);
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
  }

  getData(): ScheduledExportOverlayData | null {
    return this.overlayDataSubject.value;
  }

  clear() {
    this.overlayDataSubject.next(null);
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}
